<template>
    <div class="flex flex-col h-full gap-2 p-2">
        <ai-grid-edit
            ref="eotransGrid"
            :action="action"
            :args="args"
            :dots-click="dotsClick"
            :hasntRoute="true"
            :locked-rows="lockedRows"
            :meta="meta"
            @userDataChanged="onUserDataChanged"
        />
    </div>
</template>
<script setup>
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';

const props = defineProps({
    action: {
        type: Boolean,
        default: null,
    },
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
});

const route = useRoute();
const eotransGrid = ref();
const args = {
    select: {
        select_args: {
            eobj_id: route.params.id,
        },
    },
    save: {
        insert_args: {
            parent_id: route.params.id,
        },
    },
};
const meta = {
    keyExpr: 'eobj_id',
    viewId: 'widgetEotrans',
    columns: [
        {
            dataField: 'name',
            caption: 'Диспетчерский №',
            width: 150,
        },
        {
            dataField: 'bal_id',
            caption: 'Балансовая принадлежность',
            width: 150,
            dataType: 'number',
            editor: { type: 'ai-popup', text: 'bname' },
            component: {
                id: 'kodp',
                text: 'name',
                path: 'components/dictionary-components/ai-dictionary-virtual-grid.vue',
                saveButtonVisible: false,
                title: 'Выбор балансовой принадлежности',
                meta: {
                    columns: [
                        { field: 'kodp', text: 'kodp', visible: false },
                        { field: 'enscope_name', text: 'enscope_name', visible: false },
                        { field: 'sname', text: 'Код', width: 100 },
                        { field: 'name', text: 'Наименование', width: 250 },
                        { field: 'kod_separator', text: 'kod_separator', visible: false },
                        { field: 'kod_ecls', text: 'kod_ecls', visible: false },
                        { field: 'kod_parent', text: 'kod_parent', visible: false },
                        { field: 'inn', text: 'ИНН', width: 100 },
                        { field: 'kpp', text: 'КПП', width: 100 },
                        { field: 'addr', text: 'Адрес юридический' },
                        { field: 'pr_active', text: 'pr_active', data_type: 'boolean', visible: false },
                    ],
                    loadUrl: 'e-grid./bal/data/get',
                    keyExpr: 'kodp',
                    autoLoadData: false,
                    toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
                },
            },
        },
        {
            dataField: 'bkod_separator',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'bkod_ecls',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'bname',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'expl_id',
            caption: 'Эксплуатационная ответственность',
            width: 150,
            dataType: 'number',
            editor: { type: 'ai-popup', text: 'ename' },
            component: {
                id: 'kodp',
                text: 'name',
                saveButtonVisible: false,
                title: 'Выбор эксплуатационной ответственности',
                path: 'views/e-grid/eosrc-card/field-wrappers/component-ge-expl-id-vg.vue',
            },
        },
        {
            dataField: 'ename',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'kod_ttrans',
            caption: 'Марка трансформатора',
            width: 150,
            dataType: 'number',
            editor: { type: 'ai-popup', text: 'ttransname' },
            component: {
                id: 'kod_ttrans',
                text: 'name',
                path: 'components/dictionary-components/ai-dictionary-virtual-grid.vue',
                saveButtonVisible: false,
                title: 'Выбор марки трансформатора',
                meta: {
                    columns: [
                        { field: 'kod_ttrans', text: 'KOD_TTRANS', visible: false },
                        { field: 'name', text: 'Марка' },
                        { field: 'power', text: 'Номин. мощность Sн(кВА)' },
                        { field: 'n_obm', text: 'Кол-во обмоток' },
                        { field: 'hasmlkwnd', text: 'Расщепленная обмотка НН', alignment: 'center' },
                        { field: 'cnt_phase', text: 'Кол. фаз {Список для выбора: 1 - Однофазный; 3 - 3-х фазный }' },
                        { field: 'nv_bh', text: 'U вн(кВ)' },
                        { field: 'nv_ch', text: 'U сн(кВ)' },
                        { field: 'nv_hh', text: 'U нн(кВ)' },
                        { field: 'kod_v_bh', text: 'KOD_V_BH', visible: false },
                        { field: 'kod_v_ch', text: 'KOD_V_CH', visible: false },
                        { field: 'kod_v_hh', text: 'KOD_V_HH', visible: false },
                        { field: 'r', text: 'Сопротивление трансформатора (Ом)' },
                        { field: 'dp_xx', text: 'Потери мощности ХХ (кВт)' },
                        { field: 'i_xx', text: 'Ток холостого хода Ixx(%)' },
                        { field: 'dp_bh', text: 'Потери мощности КЗ (вн-нн) (кВт)' },
                        { field: 'dp_ch', text: 'Потери мощности КЗ (вн-сн) (кВт)' },
                        { field: 'dp_hh', text: 'Потери мощности КЗ (сн-нн) (кВт)' },
                        { field: 'u_bh_ch', text: 'U кз(вн-сн)(%)' },
                        { field: 'u_bh_hh', text: 'U кз(вн-нн)(%)' },
                        { field: 'u_ch_hh', text: 'U кз(сн-нн)(%)' },
                        { field: 'p_kz_bh', text: 'Мощность обмотки(вн) Sн-вн (кВА)' },
                        { field: 'p_kz_ch', text: 'Мощность обмотки(вн) Sн-сн (кВА)' },
                        { field: 'p_kz_hh', text: 'Мощность обмотки(вн) Sн-нн (кВА)' },
                        { field: 'ih_bh', text: 'Номин. ток Iн (вн)(А)' },
                        { field: 'ih_ch', text: 'Номин. ток Iн (сн)(А)' },
                        { field: 'ih_hh', text: 'Номин. ток Iн (нн)(А)' },
                        { field: 'p_ratio_bh', text: 'Соотношение мощностей обмоток (вн, %)' },
                        { field: 'p_ratio_ch', text: 'Соотношение мощностей обмоток (сн, %)' },
                        { field: 'p_ratio_hh', text: 'Соотношение мощностей обмоток (нн, %)' },
                        {
                            field: 'imported',
                            text: 'Импортирован',
                            data_type: 'boolean',
                            alignment: 'center',
                            visible: false,
                        },
                    ],
                    loadUrl: 'e-grid./typetrans/data/get',
                    keyExpr: 'kod_ttrans',
                    autoLoadData: false,
                    toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
                },
            },
        },
        {
            dataField: 'ttransname',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'tech_location_code',
            caption: 'Код технического места оборудования в SAP (или ее аналога)',
            width: 150,
            visible: false,
        },
        {
            dataField: 'imported',
            caption: 'Импортировано',
            width: 150,
            dataType: 'boolean',
            allowEditing: false,
        },
        {
            dataField: 'resist',
            caption: 'Сопротивление трансформатора, Ом',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'idling_power',
            caption: 'Потери мощности ХХ, кВт',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'idling_current',
            caption: 'Ток холостого хода Ixx, %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'winding_power_vn',
            caption: 'Мощность обмотки(вн) Sн-вн, кВА',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'winding_power_sn',
            caption: 'Мощность обмотки(сн) Sн-сн, кВА',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'winding_power_nn',
            caption: 'Мощность обмотки(нн) Sн-нн, кВА',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'ukz_vn_sn',
            caption: 'U кз (вн-сн), %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'ukz_vn_nn',
            caption: 'U кз (вн-нн), %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'ukz_sn_nn',
            caption: 'U кз (сн-нн), %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'pkz_vn',
            caption: 'Потери мощности КЗ (вн-нн), кВт',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'pkz_sn',
            caption: 'Потери мощности КЗ (вн-сн), кВт',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'pkz_nn',
            caption: 'Потери мощности КЗ (сн-нн), кВт',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'in_vn',
            caption: 'Номин. ток  Iн (вн), А',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'in_sn',
            caption: 'Номин. ток Iн (сн), А',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'in_nn',
            caption: 'Номин. ток Iн (нн), А',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'p_ratio_bh',
            caption: 'Соотношение мощностей обмоток (вн), %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'p_ratio_ch',
            caption: 'Соотношение мощностей обмоток (сн), %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'p_ratio_hh',
            caption: 'Соотношение мощностей обмоток (нн), %',
            width: 150,
            dataType: 'number',
            visible: false,
        },
        {
            dataField: 'pr_atg',
            caption: 'АТГ',
            width: 150,
            dataType: 'boolean',
        },
        {
            dataField: 'sezon',
            caption: 'Сезонное использование',
            width: 150,
            dataType: 'boolean',
        },
        {
            dataField: 'pr_tsn',
            caption: 'ТСН',
            width: 150,
            dataType: 'boolean',
        },
        {
            dataField: 'coment',
            caption: 'Комментарий',
        },
        {
            dataField: 'kindname',
            caption: 'Вид оборудования',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'parent_id',
            width: 150,
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'deleted',
            width: 150,
            visible: false,
            dataType: 'boolean',
            allowEditing: false,
        },
    ],
    api: {
        select: 'e-grid./eotrans/get',
        save: 'e-grid./eotrans/set',
    },
    hasntRoute: true,
};
const dotsClick = metaCell => {
    if (metaCell.cellInfo.column.dataField !== 'expl_id') return;
    const changes = eotransGrid.value.gridInstance.option('editing.changes');
    if (Array.isArray(changes) && changes.length > 0) {
        const changesRow = changes.find(item => item.key === metaCell.cellInfo.key);
        if (changesRow) {
            return changesRow.data;
        }
    }
    return metaCell.cellInfo.data;
};

const onUserDataChanged = async e => {
    const gridChanges = e.changes.gridChanges;
    let isUpdated = false;
    const columns = eotransGrid.value?.gridInstance.option('columns');
    const balIdCellTemplate = columns.find(col => col.dataField === 'bal_id').editCellTemplate;
    const explIdCellTemplate = columns.find(col => col.dataField === 'expl_id').editCellTemplate;
    gridChanges
        .filter(item => item.type === 'insert')
        .forEach(item => {
            if (!item.data.bal_id) {
                Object.assign(item.data, {
                    bal_id: props.userData.bal_id,
                    bname: props.userData.bname,
                    bkod_separator: props.userData.bkod_separator,
                });
                //если столбец использует cellTemplate, добавленное программно значение так же добавляем в DS шаблона
                if (balIdCellTemplate) {
                    eotransGrid.value?.addCellTemplateValue(
                        'bal_id',
                        'bal_id',
                        props.userData.bal_id,
                        'bname',
                        props.userData.bname
                    );
                }
                isUpdated = true;
            }
            if (!item.data.expl_id) {
                Object.assign(item.data, {
                    expl_id: props.userData.expl_id,
                    ename: props.userData.ename,
                });
                if (explIdCellTemplate) {
                    eotransGrid.value?.addCellTemplateValue(
                        'expl_id',
                        'expl_id',
                        props.userData.expl_id,
                        'ename',
                        props.userData.ename
                    );
                }
                isUpdated = true;
            }
        });
    if (isUpdated) {
        eotransGrid.value?.setUserDataChanges(gridChanges);
    }
};

const lockedRows = ref([]);
onMounted(() => {
    setTimeout(() => {
        lockedRows.value = eotransGrid.value?.gridInstance
            .option('dataSource')
            .filter(row => row['imported'] === true)
            .map(el => el[meta.keyExpr]);
    }, 500);
});

defineExpose({
    ref: eotransGrid,
});
</script>
